import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux"
import { makeStyles } from '@material-ui/core/styles'
import { Button } from "@material-ui/core";
import { valorPagoAgente } from "../../../ducks/cotizacionDuck"
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import MPagoAgente from '../MPagoAgente'

const columns = [
    { id: "No_Pago", align: "center", label: '#' },
    { id: "Monto", align: "center", label: 'Monto' },
    { id: "FechaPago", align: "center", label: 'Fecha Pago' },
    { id: "Detalles", align: "center", label: 'Detalles' }
  ];

const useStyles = makeStyles({
    root: {
      width: '100%',
    },
    container: {
      maxHeight: 440,
    },
  });

const TPagoAgente = () => {

    const dispatch = useDispatch()
    const classes = useStyles()
    const pagosAgente = useSelector(store => store.cotizacion.pagosAgente)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [open, setOpenModal] = useState(false)

    const handleChangePage = (event, newPage) => {
      setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(event.target.value);
      setPage(0)
    }

    const handleDetallesPago = (pagoAgente) => (event) =>{
      dispatch(valorPagoAgente(pagoAgente))
      setOpenModal(true);
    }

    return(
        <Paper className={classes.root}>
        <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    {
                       columns.map((column) => (
                            <TableCell
                            key={column.id}
                            align={column.align}
                            >
                            {column.label}
                            </TableCell>
                        ))
                    }
                </TableRow>
            </TableHead>
            <TableBody>
                {pagosAgente.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((pagoAgente, index) => {
                  return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={pagoAgente.idPago_Agente}>
                          <TableCell align="center">{index+1}</TableCell>
                          <TableCell align="center">{pagoAgente.ComisionMes}</TableCell>
                          <TableCell align="center">{pagoAgente.FechaPago}</TableCell>
                          <TableCell align="center">
                            <Button variant="contained" color="primary" onClick={handleDetallesPago(pagoAgente)}>Detalles</Button>  
                            {/* <Button variant="contained" color="primary" >Detalles</Button>     */}
                          </TableCell>
                      </TableRow>
                  );
                })}
            </TableBody>
            </Table>
        </TableContainer>
        <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={pagosAgente.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <MPagoAgente 
            open={open} 
            setOpenModal={setOpenModal} 
        />
        </Paper>
    )
}

export default TPagoAgente
